import React, { Component } from 'react';
import 'reactstrap';
import mergeStyles from '../utils/StyleMerge';

class DropdownMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      /*#__PURE__*/
      React.createElement("div", null, "placeholder")
    );
  }

}

DropdownMenu.defaultProps = {};
const defaultStyles = {};
export default mergeStyles(defaultStyles)(DropdownMenu);